


















import { Vue, Component, Prop } from "vue-property-decorator";

import { createPopper, Instance as PopperInstance, Modifier, OptionsGeneric } from "@popperjs/core";
import UserInfoPopup from "@share/common/user-info-popup/UserInfoPopupNew.vue";
import { UserProfile } from "@api/models/UserProfile";

@Component({ components: { UserInfoPopup } })

export default class TitleTooltip extends Vue {
    @Prop() userProfile: UserProfile | undefined;

    showPopup = false;
    closed = true;

    popper: PopperInstance | null = null;

    renderPopup() {
        this.showPopup = true;

        const children = this.$el.children;

        this.$nextTick(() => {
            const $reference = children.namedItem('user-block');
            const $tooltip = children.namedItem('tooltip') as HTMLElement | null;

            if($reference && $tooltip) {
                const options: Partial<OptionsGeneric<Partial<Modifier<"offset" | "arrow", any>>>> = {
                    placement: "right",
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [-5, 3]
                            }
                        }
                    ]
                }

                this.popper = createPopper(
                    $reference,
                    $tooltip,
                    options
                )
            }
            else {
                throw new Error("$reference or $tooltip is not defined")
            }
        });

        this.closed = false;
        const timer = setInterval(() => {
            if(this.closed) {

                // this.showPopup = false;
                clearInterval(timer);
            }
        }, 2000)
    }

    leave() {
        this.closed = true;
    }
}

